import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
  CanLoad,
  Route,
  UrlSegment,
  CanActivateChild,
  Router,
} from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { tap, take } from 'rxjs/operators';
import { AuthFacade } from '@ngrx/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(
    private auth: AuthService,
    private authF: AuthFacade,
    private router: Router
  ) { }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    (window as any).auth0 = this.auth;
    return this.auth.isAuthenticated$.pipe(take(1));
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    (window as any).auth0 = this.auth;
    return this.redirectIfUnauthenticated(state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    (window as any).auth0 = this.auth;
    return this.redirectIfUnauthenticated(state);
  }

  private redirectIfUnauthenticated(
    state: RouterStateSnapshot
  ): Observable<boolean> {
    (window as any).auth0 = this.auth;
    return this.auth.isAuthenticated$.pipe(
      tap((loggedIn) => {
        if (!loggedIn) {
          (window as any).auth0 = this.auth;
          this.auth.logout({
            returnTo: `${window.location.origin}/auth/login`
          })
          // this.router.navigateByUrl('/auth/login', {
          //   state: { returnTo: state.url },
          // });
          // this.auth.loginWithRedirect({
          //   appState: { target: state.url },
          // });
        }
        else {
          this.authF.init();
        }
      })
    );
  }
}
